import React from 'react'
import { useSelector } from 'react-redux'

import { Subnav } from '@driftt/tide-subnav'
import { generateContactsWebAppConfig } from '@driftt/app-config'
import { access } from '@driftt/traffic-control'

const SubNavigation = () => {
  const { hasContacts, hasAccounts, hasAudiences, hasLiveView } = useSelector(state => generateContactsWebAppConfig(state.user))
  const { hasGates, isBot } = access

  const hasSegmentsAccess = () => hasGates('has_segments_access') || isBot()

  const audiencesNode = {
    label: 'Audiences',
    hide: !hasAudiences,
    path: '/audiences',
    external: true,
  }

  const segmentNodes = {
    label: 'Segments',
    path: '/segments',
    external: true,
    hide: !hasSegmentsAccess(),
  }

  const contactsNode = {
    label: 'CONTACTS',
    hide: !hasContacts,
    expanded: true,
    nodes: [
      {
        label: 'All contacts',
        path: '/contacts',
        external: true
      },
      {
        label: 'Contact segments',
        path: '/contacts/segments',
        external: true,
        hide: hasSegmentsAccess,
      },
      {
        label: 'Import contacts',
        path: '/contacts/imports',
        external: true,
      },
      {
        label: 'Contacts settings',
        path: '/contacts/contact-settings',
        external: true
      },
    ]
  }

  const accountsNode = {
    label: 'ACCOUNTS',
    expanded: true,
    hide: !hasAccounts,
    nodes: [
      {
        label: 'All accounts',
        path: '/',
        hide: !hasAccounts,
        exact: true
      },
      {
        label: 'Account segments',
        path: '/segments',
        hide: !hasAccounts || hasSegmentsAccess(),
        exact: false
      },
      {
        label: 'Import accounts',
        hide: !hasAccounts,
        path: '/imports'
      },
    ]
  }

  const liveViewNode = {
    label: 'Live view',
    hide: !hasLiveView,
    path: '/live',
    external: true,
  }

  return (
    <Subnav
      title="Visitors"
      open={true}
      nodes={[
        audiencesNode,
        segmentNodes,
        contactsNode,
        accountsNode,
        liveViewNode
      ]}
    />
  )


}

export default SubNavigation
